import {useCallback} from 'react'
import useSWRImmutable from 'swr'

import {useUser} from '~/shell/user'

import {getDeimos, putDeimos} from './helpers'

type GuideStepNames = 'firstPurchase' | 'accountingSetup' | 'inviteTeam'

export type PleoGuideSteps = {
    [K in GuideStepNames]: boolean
}

export function usePleoGuideSteps() {
    const user = useUser()
    const isOwner = user?.role === 'owner'
    const companyId = user?.companyId

    const {
        data: steps,
        error,
        mutate,
    } = useSWRImmutable<PleoGuideSteps | null, Error>(
        companyId && isOwner ? `rest/v1/pleo-guide/${companyId}/steps` : null,
        getDeimos,
    )
    const isLoading = companyId && isOwner && !error && !steps

    const setPleoGuideSteps = useCallback(
        async (payload: Partial<PleoGuideSteps>) => {
            if (!companyId || !isOwner || !steps) {
                return
            }
            await putDeimos(`/rest/v1/pleo-guide/${companyId}/steps`, {...steps, ...payload})
            mutate()
        },
        [companyId, isOwner, mutate, steps],
    )

    return {steps, error, isLoading, mutations: {setPleoGuideSteps}}
}
